import { render, staticRenderFns } from "./ShipmentDashboard.vue?vue&type=template&id=812dd2c2&"
import script from "./ShipmentDashboard.vue?vue&type=script&lang=js&"
export * from "./ShipmentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDashboard.vue?vue&type=style&index=0&id=812dd2c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports